import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Le mode strict de React est temporairement désactivé pour supprimer les avertissements
  // concernant les méthodes de cycle de vie obsolètes dans certaines bibliothèques tierces
    <App />
);
